import React from 'react';

import { Header, SearchPdfForm } from 'components';

export const SearchPdf = () => {
  return (
    <>
      <Header />
      <SearchPdfForm />
    </>
  );
};
